import { createFileRoute, Outlet } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';

/** Layout-only: gives the checklist editor routes a "QC checklists" crumb back to the list. */
export const Route = createFileRoute('/_authed/_active/s/$storeId/settings/qc-checklists')({
  staticData: { crumb: 'common:nav.qcChecklists' },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'settings.read');
  },
  component: Outlet,
});
